import * as rs from 'jsrsasign';

class cmsBuilder {
    #globalParms;

    constructor(globalParms) {
        this.#globalParms = globalParms;
    }

    #validateHAlg(hAlg) {
        switch(hAlg) {
            case 'sha256': return 32;
            case 'sha512': return 64;
        }
        throw new Error(`Hash algorithm not supported (${hAlg})`);
    }

    #getDefParmsCMS() {
        const parms = {
          version: 1,
          hashalgs: [],
          econtent: {
            type: 'data', // TODO: contemplar 'tstinfo' para la TSA
            isDetached: true,
            content: {},
          },
          certs: []
        };
        return parms;
    }

    #setParmsCMS(parms, desacopledData, idKey, hashAlg, hash) {
        // TODO: agregar funcionalidad si desacopledData es falso
        const key = this.#globalParms.signer.keys.find(element => element.id === idKey);
        if (key === undefined)
            throw new Error('KeyId not found');

        parms.certs = this.#globalParms.certsACs;
        parms.certs.push(key.keyInfo.cert);
        parms.hashalgs[0] = hashAlg;
        parms.sinfos = this.#getSignerInfos(key, hashAlg, hash);
        return parms;
    }

    #getProvInfo(provId) {
        const provInfo = this.#globalParms.providers.find(element => element.id === provId);
        return provInfo;
    }

    #signAlgorithm(cert, hashAlg) {
        const iCert = new rs.X509(cert);
        const pk = iCert.getPublicKey();

        if (pk instanceof rs.RSAKey)
            switch(hashAlg.toUpperCase()) {
                case 'SHA256': return 'SHA256withRSA';
                case 'SHA512': return 'SHA512withRSA';
            }
        const typeKey = ""
        throw new Error(`Unsoported algorithm combination (${typeKey} - ${hashAlg}).`);
    }

    #getSignerInfos(key, hashAlg, hash) {
        const signerInfos = [
          {
            version: 1,
            id: { type: 'isssn', cert: key.keyInfo.cert},
            hashalg: hashAlg,
            sattrs: {
              array: [
                {
                  attr: 'contentType',
                  type: 'data',
                },
                {
                  attr: 'messageDigest',
                  hex: hash,
                },
                {
                  attr: 'signingCertificateV2',
                  array: [{ cert: key.keyInfo.cert }],
                },
                // TODO: Agregar el atributo revocationInfoArchival (pdfRevocationInfoArchival Adobe Acrobat security) necesario?
              ],
            },
            sigalg: this.#signAlgorithm(key.keyInfo.cert, hashAlg),
            signkey: key.keyInfo.privK,
          },
        ];
        if (key.keyInfo.pass !== undefined && key.keyInfo.pass !== null)
          signerInfos[0].signkeypass = key.keyInfo.pass;

        if (key.provId !== undefined) {
          const provInfo = this.#getProvInfo(key.provId);
          if (provInfo === undefined)
             throw new Error('Provider info not available');
          signerInfos[0].provName = provInfo.name;
          signerInfos[0].provInfo = provInfo;
        }

        return signerInfos;
    }

    // hashAlg ['sha256', 'sha512']
    // encodingCMS [ undefined = hex | 'base64' | 'hex' | 'binary' | 'PEM' ]  binary (NODE Buffer)
    generateDataSigned(desacopledData, idKey, hashAlg, hxHash, encodingCMS) {
        // TODO: por el momento solo permite datos desacoplados, recibiendo la digestión
        let nbytes = this.#validateHAlg(hashAlg);
        if (hxHash.length != (nbytes * 2))
            throw new Error('Hash error');

        let parms = this.#getDefParmsCMS();
        parms = this.#setParmsCMS(parms, desacopledData, idKey, hashAlg, hxHash);
        console.log({ parms });
        const sd = new rs.KJUR.asn1.cms.SignedData(parms);
        //const hxSD = sd.getEncodedHex();


        const hxCMS = sd.getContentInfoEncodedHex();

        console.log({ hxCMS });

        switch(encodingCMS) {
            case undefined:
            case 'hex':
                            return hxCMS;
            case 'binary':  return Buffer.from(hxCMS, 'hex');
            case 'base64':  return rs.hextob64(hxCMS);
            case 'PEM'   :  return rs.hextopem(hxCMS, 'PKCS7');
        }
        throw new Error(`unknown encodingCMS parameter (${encodingCMS})`)
    }
}
export {
  cmsBuilder
};
